var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 28,
    viewBox: "0 0 15 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.69 15.39L14.45 10.44H9.7V7.23C9.7 5.88 10.36 4.56 12.49 4.56H14.65V0.33C14.65 0.33 12.69 0 10.82 0C6.91 0 4.35 2.37 4.35 6.66V10.43H0V15.38H4.35V27.35C5.22 27.49 6.12 27.56 7.03 27.56C7.94 27.56 8.83 27.49 9.71 27.35V15.38H13.7L13.69 15.39Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.3f2a7079358b6d4154dae6c2705cd520.svg";
export { ForwardRef as ReactComponent };